// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* General reset and font setup */
  body, html {
    margin: 0;
    padding: 0;
    font-family: Arial, Helvetica, sans-serif;
    height: 100%;
    overflow: hidden; /* Prevents unnecessary scrollbars */
}

.ua-page-grid {
  display: grid;
  grid-template-areas: 
    "top top top"
    "left middle right";
  grid-template-rows: 80px auto;       /* Header + Content */
  grid-template-columns: 18% 60% 18%;  /* Left - Middle - Right */
  width: 100vw;
  height: auto;
  max-height: 1000vh;                       /* Fill full viewport */
  gap: 15px;
  padding: 10px;
  overflow: hidden;                    /* Prevent outer scroll */
}

.ap-left-sidebar {
  grid-area: left;
  position: fixed;        /* stays in place */
  top: 80px;              /* below header */
  left: 0;
  width: 15%;             /* match grid fraction */
  height: calc(100vh - 80px);
  border-radius: 20px;
  overflow: hidden;       /* no scroll */
  overflow-y: scroll;
  box-shadow:  0px 1px darkslategray;
  background: "pink";
}

.ua-middle-container {
    grid-area: middle;
    /* min-height: calc(100vh - 80px); */
    /* height: auto; */
    height: calc(100vh - 80px);  /* full height minus header */
    width: 100%;                 /* stretch in grid */
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-radius: 20px;
    padding: 40px;
    overflow-y: auto;             /* independent scrolling */
    scrollbar-width: none;        /* hide scrollbar (Firefox) */
    -ms-overflow-style: none;     /* hide scrollbar (IE/Edge) */
    margin-bottom: -20px;
    margin-top: -20px;
    min-height: 100vh;
    height: auto;
  }

.ua-middle-container::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

.ua-middle-container > .modal,
.ua-middle-container > .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
}

  .ua-right-sidebar {
    grid-area: right;
    position: fixed;        /* stays in place */
    top: 80px;              /* below header */
    right: 0;
    width: 18%;             /* match grid fraction */
    height: calc(100vh - 80px);
    border-radius: 20px;
    overflow: hidden;       /* no scroll */
    display: flex;
    flex-direction: column;
  }
 

.ua-central-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
    justify-content: center;
    padding: 20px;
    /* background-color: black; */
    width: 100%;
    max-width: 1210px;
    height: 600px;
    overflow-y: auto;
    margin-left: auto;
    margin-right: auto;
    position: relative; /* required so modal positions within this */
  }

  .ua-profile-container {
    background: none;
    max-width: 1000vh;
    width: 100%;  
    display: flex;
    flex-direction: row;
    border-radius: 20px;
    gap:10px;
    overflow: hidden;
    height: 100%;
    margin-top: 0px;
  }

  .ua-top-container {
    grid-area: top;
    width: 100%;
    min-height: 100px;
    height: 100px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    margin-top: -30px;

  }

  /* Middle Section */
  .ua-bottom-container {
    grid-area: bottom;
    display: flex;
    background-color: none;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    max-height: 100vh;
    height: 580px;
    border-radius: 20px;
    margin-top: 10px;
    /* box-shadow:  0px 0px 0px 1px darkslategray; */
    background-color: black;
    overflow: hidden;
  }  


  .ua-profile-card {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    text-align: center;
    transition: transform 0.3s ease-in-out;
    background: rgb(34, 31, 31);
  }
  
  .ua-profile-card:hover {
    transform: scale(1.05); /* Subtle hover effect */
  }

  .ua-header-title {
    width: 40%;           /* Fixed width (relative to parent) */
    height: 160px;        /* Fixed height */
    box-sizing: border-box;     /* Hide overflowed content */
    text-align: center;  
    display: flex;        /* Proper centering */
    align-items: left;  /* Vertical centering */
    justify-content: left; /* Horizontal centering */
    overflow: hidden;
    border-radius: 20px;
  }

  .ua-search-bar {
    margin-bottom: 10px;
    width: 60%;
    margin-top: 0px;
    border-radius: 20px;
  }

  .ua-option-navigation-container {
    width: 100px;
    height: 110px;
    border-radius: 20px;
    margin-top: 35px;
    display: flex;
    justify-content: flex-end;
    overflow: hidden;
    margin-right: 0px;
    position: relative;
    display: inline-block;
  }

  .ua-menu-option-dropdown {
    color: black;
    width: 130px;
    height: 250px;
    justify-items: center;
    position: absolute;
    z-index: 1000;
    border-radius: 6px;
    margin-left: 800px;
    margin-top: 80px;
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  }

  .ua-profile {
    width: 90%;
    height: 50%;
    background: none;
    padding: 10px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/ua-common-styles.css"],"names":[],"mappings":"EAAE,iCAAiC;EACjC;IACE,SAAS;IACT,UAAU;IACV,yCAAyC;IACzC,YAAY;IACZ,gBAAgB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,aAAa;EACb;;uBAEqB;EACrB,6BAA6B,QAAQ,qBAAqB;EAC1D,kCAAkC,GAAG,0BAA0B;EAC/D,YAAY;EACZ,YAAY;EACZ,kBAAkB,wBAAwB,uBAAuB;EACjE,SAAS;EACT,aAAa;EACb,gBAAgB,qBAAqB,yBAAyB;AAChE;;AAEA;EACE,eAAe;EACf,eAAe,SAAS,mBAAmB;EAC3C,SAAS,eAAe,iBAAiB;EACzC,OAAO;EACP,UAAU,cAAc,wBAAwB;EAChD,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB,QAAQ,cAAc;EACtC,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,0BAA0B,GAAG,6BAA6B;IAC1D,WAAW,kBAAkB,oBAAoB;IACjD,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,gBAAgB,cAAc,0BAA0B;IACxD,qBAAqB,SAAS,6BAA6B;IAC3D,wBAAwB,MAAM,6BAA6B;IAC3D,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;AAEF;IACI,aAAa,EAAE,mBAAmB;EACpC;;AAEF;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;EAEE;IACE,gBAAgB;IAChB,eAAe,SAAS,mBAAmB;IAC3C,SAAS,eAAe,iBAAiB;IACzC,QAAQ;IACR,UAAU,cAAc,wBAAwB;IAChD,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB,QAAQ,cAAc;IACtC,aAAa;IACb,sBAAsB;EACxB;;;AAGF;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB,EAAE,4CAA4C;EAClE;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;;EAEnB;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gDAAgD;IAChD,uBAAuB;IACvB,gBAAgB;EAClB;;;EAGA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB,EAAE,wBAAwB;EAClD;;EAEA;IACE,UAAU,YAAY,qCAAqC;IAC3D,aAAa,SAAS,iBAAiB;IACvC,sBAAsB,MACA,4BAA4B;IAClD,kBAAkB;IAClB,aAAa,SAAS,qBAAqB;IAC3C,iBAAiB,GAAG,uBAAuB;IAC3C,qBAAqB,EAAE,yBAAyB;IAChD,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IAEE,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qGAAqG;EACvG;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf","sourcesContent":["  /* General reset and font setup */\n  body, html {\n    margin: 0;\n    padding: 0;\n    font-family: Arial, Helvetica, sans-serif;\n    height: 100%;\n    overflow: hidden; /* Prevents unnecessary scrollbars */\n}\n\n.ua-page-grid {\n  display: grid;\n  grid-template-areas: \n    \"top top top\"\n    \"left middle right\";\n  grid-template-rows: 80px auto;       /* Header + Content */\n  grid-template-columns: 18% 60% 18%;  /* Left - Middle - Right */\n  width: 100vw;\n  height: auto;\n  max-height: 1000vh;                       /* Fill full viewport */\n  gap: 15px;\n  padding: 10px;\n  overflow: hidden;                    /* Prevent outer scroll */\n}\n\n.ap-left-sidebar {\n  grid-area: left;\n  position: fixed;        /* stays in place */\n  top: 80px;              /* below header */\n  left: 0;\n  width: 15%;             /* match grid fraction */\n  height: calc(100vh - 80px);\n  border-radius: 20px;\n  overflow: hidden;       /* no scroll */\n  overflow-y: scroll;\n  box-shadow:  0px 1px darkslategray;\n  background: \"pink\";\n}\n\n.ua-middle-container {\n    grid-area: middle;\n    /* min-height: calc(100vh - 80px); */\n    /* height: auto; */\n    height: calc(100vh - 80px);  /* full height minus header */\n    width: 100%;                 /* stretch in grid */\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    border-radius: 20px;\n    padding: 40px;\n    overflow-y: auto;             /* independent scrolling */\n    scrollbar-width: none;        /* hide scrollbar (Firefox) */\n    -ms-overflow-style: none;     /* hide scrollbar (IE/Edge) */\n    margin-bottom: -20px;\n    margin-top: -20px;\n    min-height: 100vh;\n    height: auto;\n  }\n\n.ua-middle-container::-webkit-scrollbar {\n    display: none; /* Chrome, Safari */\n  }\n\n.ua-middle-container > .modal,\n.ua-middle-container > .overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2000;\n}\n\n  .ua-right-sidebar {\n    grid-area: right;\n    position: fixed;        /* stays in place */\n    top: 80px;              /* below header */\n    right: 0;\n    width: 18%;             /* match grid fraction */\n    height: calc(100vh - 80px);\n    border-radius: 20px;\n    overflow: hidden;       /* no scroll */\n    display: flex;\n    flex-direction: column;\n  }\n \n\n.ua-central-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 20px;\n    justify-content: center;\n    padding: 20px;\n    /* background-color: black; */\n    width: 100%;\n    max-width: 1210px;\n    height: 600px;\n    overflow-y: auto;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative; /* required so modal positions within this */\n  }\n\n  .ua-profile-container {\n    background: none;\n    max-width: 1000vh;\n    width: 100%;  \n    display: flex;\n    flex-direction: row;\n    border-radius: 20px;\n    gap:10px;\n    overflow: hidden;\n    height: 100%;\n    margin-top: 0px;\n  }\n\n  .ua-top-container {\n    grid-area: top;\n    width: 100%;\n    min-height: 100px;\n    height: 100px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    overflow: hidden;\n    margin-top: -30px;\n\n  }\n\n  /* Middle Section */\n  .ua-bottom-container {\n    grid-area: bottom;\n    display: flex;\n    background-color: none;\n    flex-direction: row;\n    gap: 10px;\n    width: 100%;\n    max-height: 100vh;\n    height: 580px;\n    border-radius: 20px;\n    margin-top: 10px;\n    /* box-shadow:  0px 0px 0px 1px darkslategray; */\n    background-color: black;\n    overflow: hidden;\n  }  \n\n\n  .ua-profile-card {\n    width: 200px;\n    height: 200px;\n    border-radius: 12px;\n    overflow: hidden;\n    text-align: center;\n    transition: transform 0.3s ease-in-out;\n    background: rgb(34, 31, 31);\n  }\n  \n  .ua-profile-card:hover {\n    transform: scale(1.05); /* Subtle hover effect */\n  }\n\n  .ua-header-title {\n    width: 40%;           /* Fixed width (relative to parent) */\n    height: 160px;        /* Fixed height */\n    box-sizing: border-box;\n    overflow: hidden;     /* Hide overflowed content */\n    text-align: center;  \n    display: flex;        /* Proper centering */\n    align-items: left;  /* Vertical centering */\n    justify-content: left; /* Horizontal centering */\n    overflow: hidden;\n    border-radius: 20px;\n  }\n\n  .ua-search-bar {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    width: 60%;\n    margin-top: 0px;\n    border-radius: 20px;\n  }\n\n  .ua-option-navigation-container {\n    width: 100px;\n    height: 110px;\n    border-radius: 20px;\n    margin-top: 35px;\n    display: flex;\n    justify-content: flex-end;\n    overflow: hidden;\n    margin-right: 0px;\n    position: relative;\n    display: inline-block;\n  }\n\n  .ua-menu-option-dropdown {\n    color: black;\n    width: 130px;\n    height: 250px;\n    justify-items: center;\n    position: absolute;\n    z-index: 1000;\n    border-radius: 6px;\n    margin-left: 800px;\n    margin-top: 80px;\n    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;\n  }\n\n  .ua-profile {\n    width: 90%;\n    height: 50%;\n    background: none;\n    padding: 10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
